import { render } from "./ResourceRoomType.vue?vue&type=template&id=13d83ee9&scoped=true"
import script from "./ResourceRoomType.vue?vue&type=script&lang=js"
export * from "./ResourceRoomType.vue?vue&type=script&lang=js"

import "./ResourceRoomType.vue?vue&type=style&index=0&id=13d83ee9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d83ee9"]])

export default __exports__